import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { getDefaultLocale } from '@/store/modules/locale';

// Replace with your GraphQL server URL
const httpLink = createHttpLink({
  uri: process.env.VUE_APP_API_URL + "graphql",
});

const authLink = setContext((_, { headers }) => {
  const locale = getDefaultLocale(); // Get the locale from the store

  return {
    headers: {
      ...headers,
      'Accept-Language': locale, // Add the language header
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default apolloClient;